<template>
  <div class="width-full h-fullVh bt relative">
    <!-- 分类 tab -->
    <md-tabbar
      v-model="headerTabId"
      indicatorColor="#171A1D"
      v-if="
        (curIsAdmin || curIsCampusHeadmaster) &&
        headerTabList &&
        headerTabList.length > 1
      "
    >
      <md-tabbar-item
        v-for="item in headerTabList"
        :key="item.id"
        :name="item.id"
      >
        {{ item.name }}
      </md-tabbar-item>
    </md-tabbar>
    <!-- 分类 tab -->
    <!--  -->
    <div class="pt-12 bg-F2F2F6 p-0-16">
      <template
        v-if="
          headerTabId === (headerTabList[0] || {}).id &&
          (curIsAdmin || curIsCampusHeadmaster)
        "
      >
        <entryInfo-card
          class="mb-12"
          v-for="(face, index) in faceInfoList"
          :key="`face-${index}`"
          v-show="curIsAdmin || face.path"
          :centerInfo="face.info"
          :title="face.title"
          type="person"
          @click="handleNext(face)"
        ></entryInfo-card>
      </template>
      <template
        v-else-if="
          headerTabId === (headerTabList[1] || {}).id ||
          headerTabList.length < 2 ||
          !curIsAdmin
        "
      >
        <div
          v-show="hasFace !== 0"
          class="bg-FFFFFF p-22-0 p-0-16 fb fb-main-between fb-cross-center bd-radio-8 mb-12"
          @click="
            () => {
              hasFace && mixinRouter('/faceInput/myface')
            }
          "
        >
          <div class="font-34 c-191F25 fb fb-main-between fb-cross-center">
            <img
              src="~@/assets/images/face/face-ID.png"
              class="w-24"
              alt=""
              srcset=""
            />
            <span class="ml-12">{{
              hasFace ? '人脸已录入' : '人脸未录入'
            }}</span>
          </div>
          <div class="c-171A1D-40 font-34" v-if="hasFace">
            <i class="iconfont">&#xe66b;</i>
          </div>
          <div class="more-button font-28" @click="handleFaceInput" v-else
            >前往录入</div
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import roleTab from '@/mixin/roleTab'
import { entryInfoCard } from '@/components'
import { LEAVE_ROLE, ROOT_PATH } from '@/utils/constUtils'
import {
  mcHidePreloader,
  mcShowPreloader,
  mcOpenLink
} from '@/utils/mcSdkUtils'
import { getItem, removeItem, setItem, faceUrl } from '@/utils/comUtils'
const FACE_CACHED_KEY = 'FACE_CACHED'
export default {
  name: 'PageFaceIndex',
  mixins: [mixin, roleTab],
  components: {
    entryInfoCard
  },
  data() {
    return {
      LEAVE_ROLE,
      hasFace: 0,
      taskId: '',
      timer: null,
      faceInfoList: [
        {
          type: 'outer',
          title: '人脸录入管理（全机构）',
          info: [
            {
              title: '已录入/全部成员：',
              num: '0/0'
            }
          ],
          path: '',
          query: {}
        },
        {
          title: '学生人脸录入管理',
          info: [
            {
              title: '已录入/全部成员：',
              num: '0/0'
            }
          ],
          path: '/faceInput/memberface',
          query: { faceSandBoxType: 14 }
        },
        {
          title: '家长人脸录入管理',
          info: [
            {
              title: '已录入/全部成员：',
              num: '0/0'
            }
          ],
          path: '/faceInput/memberface',
          query: { faceSandBoxType: 16 }
        }
      ]
    }
  },
  async created() {
    this.$store.commit('memberFaceIsHeadmasterPage', false)
    if (+this.currentRole === LEAVE_ROLE.guardian) {
      this.mixinRouter('/faceInput/guardian')
      return
    }
    const { headerTabId } = this.getCachedData()
    this.createHeaderTab('face', headerTabId)
    this.getAllFace()
    this.getFaceAuth()
    this.getMyFace()
  },
  mounted() {
    // this.visibilityChange()
  },
  activated() {
    this.$store.commit('memberFaceIsHeadmasterPage', false)
    this.getAllFace()
    this.getMyFace()
  },
  methods: {
    getCachedData() {
      return getItem(FACE_CACHED_KEY) || {}
    },
    setCachedData(newVal = {}) {
      setItem(FACE_CACHED_KEY, {
        ...this.getCachedData(),
        ...newVal
      })
    },
    removeCachedData() {
      removeItem(FACE_CACHED_KEY)
    },
    visibilityChange() {
      document.addEventListener('visibilitychange', this.visibilityHandler)
    },
    visibilityHandler() {
      const pageVisibility = document.visibilityState
      // 页面变为不可见时触发
      if (pageVisibility === 'hidden') {
        console.log('离开时间点：' + new Date())
      }
      // 页面变为可见时触发
      if (pageVisibility === 'visible') {
        console.log('重新进入时间点：' + new Date())
        this.getAllFace()
        this.getMyFace()
      }
    },
    getMyFace() {
      // 我是否已录脸
      this.getApi(
        'faceCheck',
        {
          memberId: this.$store.getters.token.orgUserId
        },
        true
      ).then(res => {
        this.hasFace = res
      })
    },
    // 职工录脸统计
    getAllFace() {
      // 仅支持管理员、班主任查询统计
      if (!this.curIsCampusHeadmaster && !this.curIsAdmin) {
        return
      }
      mcShowPreloader()
      this.getApi('getFaceAllStatistic', {}, true).then(res => {
        this.taskId = (res || {}).taskNo || ''
        this.taskPolling()
      })
    },
    taskPolling() {
      console.log('taskPolling')
      this.getApi('getFaceTask', {
        taskNo: this.taskId
      }).then(res => {
        switch (res.taskStatus) {
          case 2:
            // 执行完毕
            this.faceInfoList[0].info[0].num = `${res.staffStatistic.alreadyCount}/${res.staffStatistic.totalCount}`
            this.faceInfoList[1].info[0].num = `${res.studentStatistic.alreadyCount}/${res.studentStatistic.totalCount}`
            this.faceInfoList[2].info[0].num = `${res.guardianStatistic.alreadyCount}/${res.guardianStatistic.totalCount}`
            this.$nextTick(() => {
              mcHidePreloader()
            })
            break
          case 8:
            // 异常
            mcHidePreloader()
            break
          default:
            this.timer = setTimeout(() => {
              this.taskPolling()
            }, 1500)
            break
        }
      })
    },
    handleNext(face) {
      this.$store.commit('setFaceSandBoxType', +face.query.faceSandBoxType)
      this.$store.commit('setFaceSandBoxId', '')
      if (face.type === 'outer') {
        mcOpenLink({
          url: `${this.magicH5Host}/tfacedoor/?corpId=${this.corpId}&redirectCode=1001`
        })
      } else {
        this.mixinRouter(face.path, face.query)
      }
    },
    handleFaceInput() {
      // todo
      const url = faceUrl(this.orgId, this.orgUserId, this.orgUserId)
      // mcOpenLink({ url: url })
      // window.location.href = url
      this.mixinRouter('/faceInput/faceFrame', { url })
    },
    getFaceAuth() {
      if (!getItem('faceauth')) {
        // 录脸授权
        this.getApi(
          'getFaceAuth',
          { memberId: this.orgUserId, orgId: this.orgId },
          true
        ).then(res => {
          setItem('faceauth', res)
        })
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // document.removeEventListener('visibilitychange', this.visibilityHandler)
    clearTimeout(this.timer)
    this.timer = null
    if (to && to.path === ROOT_PATH) {
      this.removeCachedData()
    } else {
      // 记录缓存数据
      this.setCachedData({
        headerTabId: this.headerTabId
      })
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.bg-F2F2F6 {
  background: #f2f2f6;
}
.more-button {
  background: #006afe;
  border-radius: 6px;
  padding: 7px 16px;
  color: #fff;
}
</style>
